// import React from 'react';
import { prepareRoutes, curi } from '@curi/router';
import Browser from '@hickory/browser';
import { curiProvider } from '@curi/react-dom';

import AllItems from './all-items';
import ScanPage from './scanner/scanPage';
import Landing from './landing';
import Search from './search';
import Archive from './archive';
import Keywords from './keywords';
import KeywordAlert from './keywordAlert';
import Privacy from './privacy';
import Profile from './profile';
import Purchase from './purchase';
import Callback from './auth/callback';
import Login from './auth/Login';
import Register from './auth/Register';
import PasswordReset from './auth/PasswordReset';
import RequestPasswordReset from './auth/RequestPasswordReset';
import blogRoutes from './blogs';
// eslint-disable-next-line import/no-webpack-loader-syntax

const routes = prepareRoutes([
  {
    name: 'Home',
    path: '',
    response() {
      return { body: Landing };
    },
  },
  {
    name: 'Search',
    path: 'search',
    response() {
      return { body: Search };
    },
  },
  {
    name: 'Archive',
    path: 'archive',
    response() {
      return { body: Archive };
    },
  },
  {
    name: 'Keywords',
    path: 'keywords',
    response() {
      return { body: Keywords };
    },
  },
  {
    name: 'KeywordAlert',
    path: 'keywords/alert/:id',
    response(params) {
      return { body: KeywordAlert };
    },
  },
  {
    name: 'AuthCallback',
    path: 'callback',
    response() {
      return { body: Callback };
    },
  },
  {
    name: 'Login',
    path: 'login',
    response() {
      return { body: Login };
    },
  },
  {
    name: 'Register',
    path: 'register',
    response() {
      return { body: Register };
    },
  },
  {
    name: 'Profile',
    path: 'profile',
    response() {
      return { body: Profile };
    },
  },
  {
    name: 'Privacy',
    path: 'privacy',
    response() {
      return { body: Privacy };
    },
  },
  {
    name: 'ResetPassword',
    path: 'reset-password',
    response() {
      return { body: PasswordReset };
    },
  },
  {
    name: 'Purchase',
    path: 'purchase',
    response() {
      return { body: Purchase };
    },
  },
  {
    name: 'RequestPasswordReset',
    path: 'request-reset-password',
    response() {
      return { body: RequestPasswordReset };
    },
  },
  {
    name: 'Scan',
    path: 'scan',
    response() {
      return { body: ScanPage };
    },
  },
  ...blogRoutes,
  {
    name: 'CSV Active',
    path: 'csv/active',
    response() {
      window.open('https://lit-mesa-84732.herokuapp.com/csv/active');
    },
  },
  {
    name: 'CSV Search',
    path: 'csv/search/(.*)',
    response(match) {
      window.open(`https://lit-mesa-84732.herokuapp.com/csv/search/${match.params[0]}`);
    },
  },
  {
    name: 'Catch All',
    path: '(.*)',
    response() {
      return { body: AllItems };
    },
  },
]);

const history = Browser();
const router = curi(history, routes);
const Router = curiProvider(router);

export { router, Router as default };



// WEBPACK FOOTER //
// ./src/routes.js